import { Radio, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type Props = {
  currentValue: boolean | null;
  selected: boolean | null;
  onSelect: (eligible: boolean) => void;
};

export const EligibilityRadioGroup = ({
  currentValue,
  selected,
  onSelect,
}: Props) => {
  const { t } = useTranslation('nachversand');

  const optionLabel = (target: boolean) => {
    const base = t(target ? 'Options.Yes' : 'Options.No');
    if (target === currentValue) {
      return `${base} ${t('Modal.CurrentTag')}`;
    }
    return base;
  };

  return (
    <Radio.Group
      label={t('Modal.RadioGroupLabel')}
      onChange={(value) => onSelect(value === 'true')}
      value={String(selected)}
    >
      <Stack mt="10px">
        {currentValue === null && (
          <Radio
            value="null"
            label={`${t('Options.NotYetDetermined')} ${t('Modal.CurrentTag')}`}
            disabled
          />
        )}
        <Radio value="true" label={optionLabel(true)} />
        <Radio value="false" label={optionLabel(false)} />
      </Stack>
    </Radio.Group>
  );
};
